import { ChatSettings, GetChatSettingsResponse } from "../../types";

type Return = Pick<ChatSettings, "unreadCount" | "pollingTimeout">;

const getChatSettingsData = (res: unknown): Return => {
  const { data } = res as GetChatSettingsResponse;

  return {
    unreadCount: data?.numberOfMissedMessages ?? 0,
    pollingTimeout: (Number(data?.pollingTimeout) || 0) * 1000,
  };
};

export { getChatSettingsData };
